import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../../components/Buttons";

export const Service = () => {
    document.title = "Xidmət";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Xidmət", value: "/products/parameters/service", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Xidmət</h2>
                    <p>
                        Yeni xidmət , xidmət yaratmaq üçün nəzərdə tutulub. Alışı olmayan, anbarda mövcud olmayan lakin satış edilə bilən xidmət anlayışıdır.
                        <NewButton>Yeni xidmət</NewButton>
                        düyməsi ilə açılan pəncərədə lazımi xanaları doldurub
                        <SaveButton /> seçimini etmək lazımdır.
                    </p>
                    <img src="/images/products/parameters/service.gif" alt="Xidmət" />
                </article>
            </div>
        </div>
    );
};
